import { UserAuthForm } from "@/auth/sign-in/components/user-auth-form";
import EcosuiteLogo from "@/assets/ecosuite.svg";
import { ThemeSwitch } from "@/components/theme-switch";

interface LoginProps {
  isSuperadmin: boolean;
}

export default function Login({ isSuperadmin }: LoginProps) {
  return (
    <div className="container relative grid h-svh flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0">
      <div className="relative hidden h-full flex-col bg-zinc-100 p-10 text-zinc-900 lg:flex dark:border-r dark:bg-zinc-900 dark:text-white">
        <div className="absolute right-4 top-4">
          <ThemeSwitch />
        </div>
        <div className="relative z-20 flex items-center text-lg font-medium">
          Ecosuite
        </div>

        <img
          src={EcosuiteLogo}
          className="relative m-auto"
          width={301}
          height={60}
          alt="Ecosuite"
        />

        <div className="relative z-20 mt-auto">
          <blockquote className="space-y-2">
            <p className="text-lg">
              Welcome to the Ecosuite{" "}
              {isSuperadmin ? "Super Admin area" : "app"}. AI meets distributed
              energy.
            </p>
          </blockquote>
        </div>
      </div>
      <div className="lg:p-8">
        <div className="mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[350px]">
          <div className="flex flex-col space-y-2 text-left">
            <h1 className="text-2xl font-semibold tracking-tight">
              {isSuperadmin ? "Super Admin Login" : "Login"}
            </h1>
            <p className="text-muted-foreground text-sm">
              Enter your email and password below to log into your{" "}
              {isSuperadmin ? "superadmin account" : "account"}
            </p>
          </div>
          <UserAuthForm isSuperadmin={isSuperadmin} />
        </div>
      </div>
    </div>
  );
}
